import { HikingIcon } from './HikingIcon';

/**
 * author: Google
 * id DA3D64F2-C874-420A-917A-0F66C9854D84
 * name hiking
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hiking.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanHikingIcon = HikingIcon;
export default HumanHikingIcon